var React = require('react');

function BaselineAlbum24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z","key":1})]);
}

BaselineAlbum24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselineAlbum24px;

BaselineAlbum24px.default = BaselineAlbum24px;
